<style lang="less">
.daBtnArea {
  width: 4.8rem;
  margin: 0 auto;
  padding: 0.2rem 0 0.4rem;
  .k-button {
    height: 0.88rem;
    line-height: 0.88rem;
    background-image: linear-gradient(270deg, #c7a862 0%, #f8efbc 100%);
    box-shadow: inset 0 0.03rem 0.06rem 0 rgba(248, 247, 242, 0.5);
    border-radius: 0.36rem;
    font-size: 0.34rem;
  }
}
</style>
<template>
  <div v-if="myUid > 0" class="daBtnArea">
    <k-button block @click="share"
      ><span v-if="isLeader">邀请好友助力</span
      ><span v-else>邀请好友给TA助力</span></k-button
    >
  </div>
  <div v-else class="daBtnArea">
    <k-button block @click="goRegister()">注册为好友助力</k-button>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('laxin/da', ['myUid', 'isLeader'])
  },
  methods: {
    ...mapActions('account', ['goRegister']),
    ...mapActions('laxin', ['share'])
  }
}
</script>
